var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit/Close "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.953 1.18268L14.1297 1.35946L13.953 1.18268L8 7.13564L2.04705 1.18268C1.80347 0.939106 1.42626 0.939106 1.18268 1.18268C0.939106 1.42626 0.939106 1.80347 1.18268 2.04705L7.13564 8L1.18268 13.953L1.35946 14.1297L1.18268 13.953C0.939106 14.1965 0.939105 14.5737 1.18268 14.8173C1.30561 14.9402 1.48005 15 1.61486 15C1.74968 15 1.92412 14.9402 2.04705 14.8173L8 8.86437L13.953 14.8173C14.0759 14.9402 14.2503 15 14.3851 15C14.5199 15 14.6944 14.9402 14.8173 14.8173C15.0609 14.5737 15.0609 14.1965 14.8173 13.953L8.86437 8L14.8173 2.04705C15.0609 1.80347 15.0609 1.42626 14.8173 1.18268C14.5737 0.939105 14.1965 0.939106 13.953 1.18268Z",
    fill: "#4F4F4F",
    stroke: "#4F4F4F",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.d601331a4c0b2f9ab84e3718f0575650.svg";
export { ForwardRef as ReactComponent };